export default "__VITE_ASSET__DWV_n1po__"